module.exports = __webpack_public_path__ + "static/media/livox-logo.e0ef5a64.png";